import axios from 'axios';
import { API_BASE_URL } from 'utils/constants';

export const handleFetchDashboard = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/container/dashboard',
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchDashboardChart = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/container/dashboard/users',
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};
